<main class="account-page">
  <section class="account-card">
    <p class="eyebrow">Email Verification</p>
    <h1>Enter your passcode</h1>
    <p class="lede">
      Check your inbox for the six-digit code from Hebern. Verification logs you
      in automatically.
    </p>

    <form [formGroup]="form" (ngSubmit)="submit()" class="account-form">
      <label>
        <span>Email</span>
        <input
          type="email"
          formControlName="email"
          autocomplete="email"
          placeholder="you@example.com"
        />
        @if (form.controls.email.invalid && form.controls.email.touched) {
        <small>Please enter a valid email.</small>
        }
      </label>

      <label>
        <span>Passcode</span>
        <input
          type="text"
          formControlName="passcode"
          inputmode="numeric"
          autocomplete="one-time-code"
          maxlength="6"
          placeholder="000000"
        />
        @if (form.controls.passcode.invalid && form.controls.passcode.touched) {
        <small>Enter the six-digit passcode.</small>
        }
      </label>

      @if (errorMessage) {
      <div class="form-alert form-alert--error">{{ errorMessage }}</div>
      }

      <button type="submit" class="primary-action" [disabled]="isLoading">
        {{ isLoading ? 'Verifying...' : 'Verify and Continue' }}
      </button>
    </form>

    <div class="account-links">
      <a routerLink="/account/signup">Start over</a>
      <span aria-hidden="true">|</span>
      <a routerLink="/login">Log in</a>
    </div>
  </section>
</main>
